module.exports = __webpack_public_path__ + "img/placehold@3x.7cdb12a9.png";